export default {
  backendApi: "https://api.keycma.com",
  // https://api.keycma.com
};
